import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=38c2b832&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=38c2b832&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2b832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c2b832')) {
      api.createRecord('38c2b832', component.options)
    } else {
      api.reload('38c2b832', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=38c2b832&scoped=true", function () {
      api.rerender('38c2b832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performanceCalculation/views/result_statement/monthly_performance_report/form/detail.vue"
export default component.exports